import { Injectable } from '@angular/core';
import {
  UrlMatcherFactory,
} from '@uirouter/angular';

@Injectable({
  providedIn: 'root',
})
export class RouteFormatterService {
  constructor(
    private urlMatcherFactory: UrlMatcherFactory,
  ) { }

  formatRelativeRoute(routePattern: string, parentRoutePattern: string, params?: any): string {
    params = (typeof params !== 'undefined') ? params : {};
    if (routePattern.indexOf(parentRoutePattern + '/') === 0) {
      routePattern = routePattern.substring(parentRoutePattern.length);
    }
    const route = this.urlMatcherFactory.compile(routePattern).format(params);

    return route;
  }
}
